<template>
  <div class="kui-address" :class="options.isShowUseIDAddress ? 'is-use-id' : ''">
    <kui-validatebox ref='validator' :options='options'>
      <div slot="validatebox-content" :class='{"redBorder":!isPassValidate }' class="address-wrap">
        <span v-show="options.title" class="kui-address-title">{{titleName}}</span>
        <el-cascader class="address1" size="large" :disabled="disabled" :options="addressOptions" v-if='showProvince'
          v-model="value1" @blur="validate" @focus="hideTips" placeholder="请选择省市区">
        </el-cascader>
        <el-input class="address2" v-model="value2" :disabled="disabled" @blur="validate" @focus="hideTips"
          placeholder="请输入详细地址">
        </el-input>
        <el-button class="use-id-address" v-if="options.isShowUseIDAddress" :disabled="disabled" @click="useIDAddress">
          使用证件地址
        </el-button>
      </div>
    </kui-validatebox>
  </div>
</template>
<script>
import regionData from "./src/city-data";
export default {
  name: "kui-address",
  props: {
    options: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data: function () {
    return {
      disabled: false,
      value: "",
      value1: [],  //省市区地址
      value2: "", //详细地址
      isPassValidate: true,  //校验是否通过
      addressOptions: regionData,  //省市json数据
      zipCode: "",//邮编
      showProvince: true, //展示省市区三级联动
    };
  },
  computed: {
    titleName () {
      return this.options.title ? this.options.title + ":" : "";
    },
  },
  watch: {
    value1 (v) {
      this.zipCode = this.parseAddress(v.join(""))[2];
      this.value = v.join("") + this.value2;
    },
    value2 (v) {
      this.value = this.value1.join("") + v;
    }
  },
  methods: {
    address (opts, ...params) {
      if (_.isString(opts)) {
        if (params.length > 1) {
          this[opts].call(this, params[0], params[1]);
        } else {
          this[opts].call(this, params[0]);
        }
      } else {
        //传进来参数是对象 就和options合并 并赋值
        _.assign(this.options, opts);
        _.each(this.options, (v, k) => {
          if (!_.isFunction(v) && k == "val") {
            this.setValue(v);
          }
        });
      }
    },
    getZipCode () {
      return this.zipCode;
    },
    parseAddress (value) {
      if (value == "" || typeof (value) == "undefined") {
        consoleLog("地址为空");
        return [[], ""];
      }
      let temp_value1 = [];
      let temp_value2 = "";
      let zipCode = "";
      let func = (addressData, addressValue) => {
        _.each(addressData, function (value, index) {
          if (addressValue.indexOf(value.label) === 0) {
            temp_value1.push(value.label);
            temp_value2 = addressValue.substr(value.label.length);
            if (value.code) {
              zipCode = value.code;
            }
            func(value["children"], temp_value2);
            return false;
          }
        });
      };
      func(regionData, value);
      if (temp_value1.length == 0) {
        //省市区没有解析到 隐藏省市区联动选择
        this.showProvince = false;
      }
      return [temp_value1, temp_value2, zipCode];
    },
    useIDAddress () {
      if (this.options.onClickButton) {
        this.options.onClickButton();
      }
    },
    hideTips () {
      this.isPassValidate = true;
      this.$refs.validator.hideTips();
    },
    validate (v) {
      this.isPassValidate = this.$refs.validator.validate(this.value);
      if (this.isPassValidate) {
        this.isPassValidate = this.$refs.validator.validate(this.value2);
      }
      return this.isPassValidate;
    },
    getValue: function () {
      return this.value1.join("") + this.value2;
    },
    setValue: function (value) {
      let addressArr = this.parseAddress(value);
      if (addressArr[0].length > 0) {
        this.value1 = addressArr[0];
        this.value2 = addressArr[1];
      } else {
        //省市区没有解析到 隐藏省市区联动选择 把当前value值作为详细地址
        this.value2 = value;
      }
      this.zipCode = addressArr[2];
    },
    setEnabled: function () {
      this.disabled = false;
    },
    setDisabled: function () {
      this.disabled = true;
    },
    getData: function () {
      return {
        [this.options.field]: this.getValue()
      };
    }
  },
  mounted () {

  },

};
</script>
<style lang='less' scoped>
.kui-address {
  .address-wrap {
    display: flex;
    align-items: center;
    .kui-address-title {
      margin-right: 8px;
    }
    .address2 {
      width: auto;
      margin-left: 20px;
      .el-input__inner {
        width: 220px;
      }
    }
    .el-button {
      margin-left: -3px;
    }
  }
}
.is-use-id {
  .address-wrap {
    .el-input {
      input {
        border-top-right-radius: 0px;
        border-bottom-right-radius: 0px;
      }
    }
    .el-button {
      margin-left: -1px;
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/lib/ui/default/address/index.vue